var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstames(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0455 0.0234375H19.9545C8.93392 0.0234375 0 8.95999 0 19.9838V20.0749C0 31.0987 8.93392 40.0352 19.9545 40.0352H20.0455C31.0661 40.0352 40 31.0987 40 20.0749V19.9838C40 8.95999 31.0661 0.0234375 20.0455 0.0234375Z",
    fill: "url(#paint0_linear_12630_32983)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9084 20.0288V20.0975C31.8761 25.8239 27.7813 30.6083 22.3649 31.7045C21.9977 31.7774 21.6263 31.8349 21.248 31.8755C20.8388 31.9176 20.4211 31.9414 20.0007 31.9414C18.3471 31.9414 16.7719 31.6036 15.3397 30.991L9.81398 31.5797C8.87084 31.6807 8.17436 30.7176 8.56535 29.8541L10.0508 26.5641C8.81339 24.687 8.09167 22.4399 8.09167 20.0288C8.09167 13.4628 13.4352 8.11768 20.0007 8.11768C26.2089 8.11768 31.3226 12.895 31.8607 18.9677C31.893 19.3153 31.9084 19.6728 31.9084 20.0288Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7254 16.5507C26.2593 16.1133 26.9922 16.7679 26.6167 17.3469L24.1166 21.2047L22.7937 23.2457C22.512 23.6802 21.9206 23.784 21.5072 23.4714L19.314 21.8074L17.9617 20.7827C17.8524 20.7 17.6996 20.7028 17.5931 20.7897L14.2746 23.498C13.7407 23.934 13.0091 23.2793 13.3847 22.7004L15.7264 19.0893L17.0494 17.0483C17.331 16.6137 17.9224 16.51 18.3358 16.8226L20.4645 18.4361L21.8155 19.4594C21.9262 19.5421 22.079 19.5393 22.1855 19.4524L25.7254 16.5493V16.5507Z",
    fill: "url(#paint1_linear_12630_32983)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_12630_32983",
    x1: 5.84381,
    y1: 34.1897,
    x2: 34.1631,
    y2: 5.87872,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0498FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#5C5EFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#F44E90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FA8679"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_12630_32983",
    x1: 15.037,
    y1: 25.0316,
    x2: 25.008,
    y2: 15.0635,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0498FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#5C5EFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#F44E90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FA8679"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstames);
export default __webpack_public_path__ + "static/media/instames.ca09b5dd400550713533f8a6609886ae.svg";
export { ForwardRef as ReactComponent };